import { getActionAuthorization } from '../commons/utils';

const EXTERNAL_CLIENT_ACTIONS_RESOURCE = {
  CREATE: 'external-client:create',
  EDIT: 'external-client:edit',
  DELETE: 'external-client:delete',
};

export const canCreateExternalClient = (actions) =>
  getActionAuthorization(actions, EXTERNAL_CLIENT_ACTIONS_RESOURCE.CREATE);

/**
 * Gates the external client edition and, with it, every B2B catalog mutation — including the ones
 * reached from the product admin pages (add / remove a product to catalogs, edit catalog prices).
 */
export const canEditExternalClient = (actions) =>
  getActionAuthorization(actions, EXTERNAL_CLIENT_ACTIONS_RESOURCE.EDIT);

export const canDeleteExternalClient = (actions) =>
  getActionAuthorization(actions, EXTERNAL_CLIENT_ACTIONS_RESOURCE.DELETE);
